import { useEffect } from "react";
import queryString from "query-string";

const ScreenshotFlag = () => {
  const qs: any = queryString.parse(window.location.search);
  const selector = qs["selector"];
  useEffect(() => {
    const CHECK_INTERVAL = 200;
    const TIMEOUT = 60 * 1000;
    const SCREENSHOT_FLAG = "screenshot-flag";
    const initTime = Date.now();

    let notExistLoadingTagCount = 10;

    const checkTimerHandle = window.setInterval(() => {
      if (Date.now() - initTime > TIMEOUT) {
        window.clearInterval(checkTimerHandle);
        document.body.classList.add(SCREENSHOT_FLAG);
      } else {
        if (
          document.querySelector(".mantine-loader") === null &&
          document.querySelector(".mantine-Skeleton-visible") === null &&
          document.querySelector('[class="highcharts-loading"]') === null
        ) {
          notExistLoadingTagCount -= 1;

          if (notExistLoadingTagCount <= 0) {
            console.log(".screenshot-flag done.");
            window.clearInterval(checkTimerHandle);

            if (selector) {
              const screenshotEl = document.querySelector(selector);

              if (screenshotEl) {
                document.body.innerHTML = screenshotEl?.outerHTML;
              }
            }
            document.body.classList.add(SCREENSHOT_FLAG);
          }
        }
      }
    }, CHECK_INTERVAL);
    // eslint-disable-next-line
  }, []);

  return null;
};

export default ScreenshotFlag;
